import { defineFormKitConfig } from "@formkit/vue";
import { rootClasses } from "./formkit.theme";
import { nb } from "@formkit/i18n";
import { createAutoAnimatePlugin } from "@formkit/addons";
import { genesisIcons } from "@formkit/icons";
import { createProPlugin, inputs } from "@formkit/pro";
import { createMultiStepPlugin } from "@formkit/addons";
//import "@formkit/addons/css/multistep";

const pro = createProPlugin("fk-5bd1f671f", inputs);

export default defineFormKitConfig({
  config: {
    rootClasses,
  },
  locales: { nb }, // en is added by default
  locale: "nb",
  plugins: [pro, createAutoAnimatePlugin(), createMultiStepPlugin()],
  icons: {
    ...genesisIcons,
  },
});
